import * as Sentry from "@sentry/react";
import { Middleware } from "redux";

export default function sentryMiddleware(): Middleware {
    let lastOrderRef: string | undefined;
    let lastOrderType: string | undefined;

    return (store) => (next) => (action) => {
        const result = next(action);

        const orderRef: string | undefined = store.getState().general?.orderRef;
        if (orderRef && orderRef !== lastOrderRef) {
            lastOrderRef = orderRef;
            Sentry.setTag("orderRef", orderRef);
            Sentry.setUser({ id: orderRef });
        }

        const orderType: string | undefined = store.getState().general?.orderType;
        if (orderType && orderType !== lastOrderType) {
            lastOrderType = orderType;
            Sentry.setTag("orderType", orderType);
        }

        return result;
    };
}
